export default __webpack_public_path__ + "static/media/section1-img2.fd513c7b.png";